import React, { useState } from 'react';
import axios from 'axios';
import "./Formstyle.css";

const Forms = ({ onSubmit }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      Name: name,
      Email: email,
      Subject: subject,
      Message: message,
    };

    // Call the onSubmit function with the form data
    onSubmit(data);

    // Reset the form fields
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
  };

  return (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <label>Your Name</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
        <label>Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label>Subject</label>
        <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
        <label>Message</label>
        <textarea rows="6" placeholder="Type Your message here" value={message} onChange={(e) => setMessage(e.target.value)} />
        <button className="btn" type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Forms;
